import * as React from "react";
import { StudiengangsInfoFieldsItem } from "../items/StudiengangInfoItem"
import { HeaderStudiengangInfoField } from '../component/HeaderStudiengangInfo'
import DocumentFieldItem from "../items/DocumentFieldItem"
import { RouteComponentProps } from "react-router";
import { getaccesToken, getDownloadDokumentGuid, getSubsequentDocumentGuid, SaveBewerberNachreichungDocument } from '../DataAccess';
import { isUndefined } from 'util';
import { HeaderLogoIntern } from '../component/HeaderLogo'
import { IDokument, IUploadDocument } from "../interface/Interface";
import { FileUploader } from '../component/FileUploader'
import { LoadingAnimation } from '../component/loadingComponent'
import fileDownload from "js-file-download"
import Footer from '../component/footer'
import { SaveErrorRequest } from '../component/SaveErrorRequest'

interface State {
  Document: DocumentFieldItem,

  studienganginfo: StudiengangsInfoFieldsItem,
  errors:
  {
    errorValuetext: string
    errortext: string
    submiterror: boolean
  },
  disabled: boolean, submitted: boolean, accessToken: string, ready: boolean, timeout: boolean
}

export default class SubsequentDocuments extends React.Component<RouteComponentProps<any>, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      errors: { errorValuetext: 'All mandatory documents must be uploaded!', errortext: '', submiterror: false },
      Document: {
        Phase3Isgespeichert: false,
        Phase3fertig: false,
        bewerberID: 0,
        stgGuid: '',
        fotodokument: { bewerbungsunterlageID: 0, clientId: 0, bewerbungsunterlagebezeichnung: '', typ: '', isoptional: true, dokumentid: 0, beschreibung: '', filename: '', isessay: false },
        pflichtdocumentlist: [{ clientId: 0, bewerbungsunterlageID: 0, bewerbungsunterlagebezeichnung: '', dokumentid: 0, isoptional: false, typ: '', beschreibung: '', filename: '', isessay: false }],
        optionaldocumentlist: [{ clientId: 0, bewerbungsunterlageID: 0, bewerbungsunterlagebezeichnung: '', dokumentid: 0, isoptional: true, typ: '', beschreibung: '', filename: '', isessay: false }]
      },
      studienganginfo: {
        ID: 0, Studiengangsartbezeichnung: '', Studiengangsbezeichnung: '', Studiengangsortbezeichnung: '', GuideLink: ''
      },
      disabled: false, submitted: false, accessToken: '-1', ready: false, timeout: false
    }
    setTimeout(() => this.setState({ timeout: true }), 50000);
    let guid = this.getGuid();
    if ((guid === "")) {
      this.props.history.push('/');
    }
    this.checkaccesstoken(guid);
  }
  locationError() {
    this.props.history.push({
      pathname: '/error'
    })
  }

  handleValidation() {
    let fields = this.state.Document;
    //let errors = this.state.errors;
    //errors.errortext = '';
    let formIsValid = true;

    // dokumente checken
    for (let u = 0; u < fields.pflichtdocumentlist.length; u++) {
      let value = fields.pflichtdocumentlist[u];
      if (!value.isoptional && value.dokumentid === 0) {
        formIsValid = false;
        //errors.errortext = errors.errorValuetext;
        break;
      }
    }

    return formIsValid;
  }

  clickSubmithandler = async (event: any) => {

    event.preventDefault();
    this.setState({ disabled: true })
    let errors = this.state.errors;
    errors["submiterror"] = false;
    this.setState({ errors });

    if (this.handleValidation()) {

      if (this.state.accessToken !== "-1" && this.state.accessToken !== null) {

        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.Document.Phase3fertig = true;
        let json = JSON.stringify(this.state.Document);

        const response = await SaveBewerberNachreichungDocument(this.state.accessToken, json);

        if (response === 200) {
          sessionStorage.clear();
          sessionStorage.setItem('StgID', this.state.studienganginfo.ID.toString());
          this.props.history.push({
            pathname: '/successfullapplied'
          })

        } else {
          this.setState({ disabled: false })
          let errors = this.state.errors;
          errors["submiterror"] = true;
          this.setState({ errors });
        }
      }
    } else {
      window.scrollTo(0, 800)
      console.log('validation failed')
      this.setState({ disabled: false })
    }
  }
  getGuid(): string {
    let data = sessionStorage.getItem('applicationguid');
    return data || "";
    // let search = this.getUrlParams();
    // return search.get("applicationguid") || "";
  }

  getUrlParams(): URLSearchParams {
    if (!this.props.location.search) return new URLSearchParams();
    return new URLSearchParams(this.props.location.search);
  }

  checkaccesstoken = async (guid: string) => {

    if (this.state.accessToken === "-1") {
      await getaccesToken().then(res => {
        if (res !== null && res !== isUndefined && typeof res === "string") {
          this.setState({ accessToken: res.toString() })
          this.checkGuid(guid);
        }
      })
    } else await this.checkGuid(guid);
  }

  checkGuid = async (guid: string) => {


    await getSubsequentDocumentGuid(this.state.accessToken, guid)
      .then(res => {

        let TTPBewerberItem = JSON.parse(JSON.stringify(res));
        let Document = this.state.Document;
        let studienganginfo = this.state.studienganginfo;
        Document.stgGuid = TTPBewerberItem.StrGuid;

        studienganginfo.ID = TTPBewerberItem.StudiengangID as number;
        studienganginfo.Studiengangsartbezeichnung = TTPBewerberItem.Studiengangsartbezeichnung;
        studienganginfo.Studiengangsbezeichnung = TTPBewerberItem.Studiengangsbezeichnung;
        studienganginfo.Studiengangsortbezeichnung = TTPBewerberItem.Studiengangsortbezeichnung;
        studienganginfo.GuideLink = TTPBewerberItem.GuideLink;

        if (Document.stgGuid !== guid) {
          this.props.history.push({
            pathname: '/',
            state: { accessToken: this.state.accessToken }
          })
        } else {

          if (TTPBewerberItem.pflichtdocumentlist !== null) {
            let liste = TTPBewerberItem.pflichtdocumentlist as [];
            if (liste.length > 0) {
              var tmplU = [] as IDokument[];
              for (let u = 0; u < liste.length; u++) { tmplU.push(liste[u] as IDokument); }
              Document.pflichtdocumentlist = tmplU;
            }
          }

          this.setState({ Document, studienganginfo, ready: true });
        }
      })

  }

  handleupload = async (event: IUploadDocument) => {

    if (event.clientid === 0) {
      let fotodokument = this.state.Document;
      fotodokument.fotodokument.dokumentid = event.dokumentid;
      fotodokument.fotodokument.filename = event.filename;
      await this.setState({ Document: fotodokument });

    } else {

      let dokument = this.state.Document;
      let arr = dokument.pflichtdocumentlist;
      var _index = arr.findIndex(value => value.bewerbungsunterlageID === event.bewerbungsunterlageID);
      const _l = arr[_index];

      _l.dokumentid = event.dokumentid;
      _l.filename = event.filename;
      await this.setState({ Document: dokument });
    }
  }

  handledownload = async (event: number) => {
    await getDownloadDokumentGuid(this.state.accessToken, this.state.Document.stgGuid, event).then(
      res => {

        let TTPBewerberItem = JSON.parse(JSON.stringify(res));

        if (TTPBewerberItem === null || TTPBewerberItem.downloaddocument === null) return;
        var dataUrl = "data:application/octet-binary;base64," + TTPBewerberItem.downloaddocument.document;

        fetch(dataUrl)
          .then(res => res.arrayBuffer())
          .then(buffer => {
            fileDownload(new Uint8Array(buffer), TTPBewerberItem.downloaddocument.filename);

          })

      }
    )
  }

  handleFotodownload = async (event: number) => {

  }

  handleRedirectFotoUpload = (event: number) => {

  }

  handleRedirectMotivationschreiben = (event: number) => {

  }


  render() {
    if (this.state.timeout === true && !this.state.ready)
      this.locationError();
    if (!this.state.ready)
      return <LoadingAnimation />;
    return (
      <div id="visual-portal-wrapper" className="clearfix">
        <HeaderLogoIntern />
        <div id="portal-columns" className="row">
          <div id="portal-columns-content" className="container">
            <h1>IMC Krems online application system</h1>
            <HeaderStudiengangInfoField StudiengangsArtbezeichnung={this.state.studienganginfo.Studiengangsartbezeichnung} StudiengangsOrtbezeichnung={this.state.studienganginfo.Studiengangsortbezeichnung} Studiengangsbezeichnung={this.state.studienganginfo.Studiengangsbezeichnung}
            ></HeaderStudiengangInfoField>

            <form>
              <fieldset id="Fieldset_P">
                <legend>
                  <span id="Label_Fieldset_P">Documents required to complete the application</span>
                </legend>
                <p className="discreet">
                  Please upload the pending documents required to complete your application here.</p>
                <h4>Important pointers</h4><br></br>
                Upload each document separately. Thus, when scanning multiple page documents, please make sure that all pages are saved in only one digital file.
                Useful explanations can be found in the <a href={this.state.studienganginfo.GuideLink} target="_blank" rel="noopener noreferrer">Guide to applying online</a><br /><br />
                Please use only the following document formats (max. 5 MB per document):
                <ul className="discreet">
                  <li>PDF</li>
                  <li>JPEG/JPG</li>
                </ul>
                You can replace uploaded documents with a different document until you submit your complete online application.<br /><br />
                <h4>International degrees</h4><br></br>
                All certificates issued outside Austria must be translated into German or English and legalised by a notary or by the Austrian diplomatic representation. Please make sure that the digital file contains a full scan of the original document, a complete scan of the proper translation and the legalisation seal.
                <h3>
                  <span id="PflichtdokumentLabel"> Pending Documents</span>
                </h3>
                {this.state.errors.errortext !== "" && <span style={{ color: "orange", float: "left", marginBottom: "15px" }}>{this.state.errors.errortext}</span>}
                <ol className="nthList form" >

                  {this.state.Document.pflichtdocumentlist.map((value, index) => <li key={index} className="w-100">
                    <FileUploader isoptional={value.isoptional} stgguid={this.state.Document.stgGuid} handleUpload={this.handleupload}
                      handleRedirectFotoUpload={this.handleRedirectFotoUpload} handleRedirectMotivationschreiben={this.handleRedirectMotivationschreiben}
                      accesstoken={this.state.accessToken} handleFotoDownload={this.handleFotodownload}
                      allowtyp={['jpg', 'jpeg', 'pdf']} handleDownload={this.handledownload} Text={value.bewerbungsunterlagebezeichnung} typ={value.typ}
                      htmlname='' filename={value.filename} documentid={value.dokumentid} bewerbungsunterlageid={value.bewerbungsunterlageID}
                      clientid={index + 1} isessay={value.isessay} ></FileUploader></li>)}
                </ol>
              </fieldset>


              <div className="formControls clearfix">
                {this.state.errors["submiterror"] && <SaveErrorRequest />}
                <fieldset>
                  <ul className="form">
                    {this.handleValidation() &&
                      <li className="w-100">
                        {this.state.errors.errortext !== "" && <span style={{ color: "orange", float: "left", marginBottom: "15px" }}>{this.state.errors.errortext}</span>}
                        <button type="button" id="_Buttonright" className="button orangesmall right" disabled={this.state.disabled} onClick={this.clickSubmithandler} >Finish</button>
                      </li>}
                  </ul>
                </fieldset>
              </div>
            </form>
          </div>
        </div>
        <Footer></Footer>
      </div >
    );
  }
}